// HOIKU-1949のfacilityReserveを参照
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'
import { LotteryReserveEntry } from './lotteryReserve'
import { CommonInput } from '../../lotteryReservation'

export type LotteryReserveCancelEntry = Omit<
  Required<Omit<LotteryReserveEntry, 'isCertificateUseReasonViewFlags' | 'commonInput'>>,
  'diagonosis'
> & { diagonosis?: { first: string | null; second: string | null } } & Omit<CommonInput, 'consentCheck'> & {
  cancelReason: { select: string; stringify?: string }
};

interface LotteryReserveCancelState {
  entry?: LotteryReserveCancelEntry
}

const initialState: LotteryReserveCancelState = {}

export const lotteryReserveCancelSlice = createSlice({
  name: 'lotteryReserveCompleted',
  initialState,
  reducers: {
    setLotteryCancelReserve: (state, action: PayloadAction<LotteryReserveCancelEntry>) => {
      state.entry = action.payload
    },
    clearLotteryReserveCancel: (state) => {
      delete state.entry
    },
  },
})

export const { setLotteryCancelReserve, clearLotteryReserveCancel } = lotteryReserveCancelSlice.actions
export const selectLotteryReserveCancelEntry = (state: RootState) => state.lotteryReserveCancel.entry
export default lotteryReserveCancelSlice.reducer
